import { serialize } from 'utils';

/* eslint-disable no-useless-catch */

import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/entity-materials';

export const EntityMaterialApi = {
  findWithEntity: async (options: FindOptions) => {
    let url = `${pathname}/find-with-entity`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (options: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInheritEntityMaterial: async (
    option: FindEntityMaterialForInheritQuery
  ) => {
    let url = `${pathname}/find-inherit-entity-material`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    const url = pathname;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindOneWithEntity {
  id: string;
  entityID: string;
}

export interface FindEntityMaterialForInheritQuery {
  name?: string;
  entityID?: string;
  entityMaterialID?: string;
}
